module.exports = __webpack_public_path__ + "static/img/js_.1f539ca9.jpg";